module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-card"
  }, [_c('div', {
    staticClass: "graph-card-title"
  }, [_c('span', {
    staticClass: "graph-card-title__primary"
  }, [_vm._v("\n      Turbidity (NTU)\n      "), _c('v-dialog', {
    attrs: {
      "content-class": "nww-dialog",
      "persistent": ""
    },
    model: {
      value: (_vm.controls.turbidityDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "turbidityDialog", $$v)
      },
      expression: "controls.turbidityDialog"
    }
  }, [_c('i', {
    staticClass: "material-icons graph-card-title__icon",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n          info_outline\n        ")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Turbidity")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Turbidity is the measure of the relative clarity of water. High levels of turbidity are a result of the presence of suspended and dissolved matter, such as clay, silt, finely divided organic matter, plankton and other microscopic organisms, organic acids, and dyes. We typically see the highest turbidity levels during and after heavy rain events. During a rainstorm, particles from the surrounding land are washed into the river making the water a muddy brown color, indicating water that has higher turbidity values. Also, during high flows, water velocities are faster and water volumes are higher, which can more easily stir up and suspend material from the stream bed, causing higher turbidity levels.")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-nww btn btn--raised",
    nativeOn: {
      "click": function($event) {
        _vm.controls.turbidityDialog = false
      }
    }
  }, [_vm._v("Okay")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "graph-card-title__secondary--strong"
  }, [_vm._v("\n        Last Result:\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "graph-card-title__secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedSite ? _vm.selectedSite.lastTurbidityResult : null) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "graph-card__graph-wrapper"
  }, [_c('vue-highcharts', {
    ref: "turbidityChart",
    attrs: {
      "id": "chart2",
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c6d1232"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/panels/TurbidityChart.vue
// module id = 445
// module chunks = 1